import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { OfficeStatus } from "../../../../enums";
import { Api } from "../../../../services/api";
import { Company } from "../../../../services/api/types/Companies";
import { MakeOffice } from "../../../../services/api/types/Offices";
import { handleAxiosError } from "../../../../services/utils/handleAxiosError";
import { OfficeForm } from "../OfficeForm";
import {
  OfficeFormHeader,
  OfficeFormType,
} from "../OfficeForm/officeFormSchema";
import { ColumnContainer } from "../../Admin.styles";
import axios from "axios";
import { FormikHelpers } from "formik";

export const AddOffice: React.FC<{}> = () => {
  const history = useHistory();

  const [companiesMap, setCompaniesMap] = useState<Map<string, Company>>(
    new Map()
  );

  const getCompanies = () => {
    Api.companies
      .get()
      .then(res => {
        const companies = new Map<string, Company>();
        res.data.companies.map(company => {
          companies.set(company.name, company);
        });
        setCompaniesMap(companies);
      })
      .catch(error => {
        console.error(error);
        handleAxiosError(error);
      });
  };

  useEffect(() => {
    getCompanies();
  }, []);

  const submitValues = (
    values: OfficeFormType,
    { setErrors }: FormikHelpers<OfficeFormType>
  ) => {
    const data: MakeOffice = {
      status:
        values.status === "Active"
          ? OfficeStatus.Active
          : OfficeStatus.Inactive,
      name: values.name || "",
      address: values.address || "",
      companyIds: (values.companies as Array<string>).map(
        company => (companiesMap.get(company) as Company).id
      ),
    };
    Api.offices
      .createOffice(data)
      .then(res => {
        const currentLocation = history.location;
        currentLocation.pathname =
          currentLocation.pathname.split("/").slice(0, -1).join("/") +
          `/${res.data.id}/edit`;
        history.push(currentLocation);
      })
      .catch((error: Error) => {
        if (
          axios.isAxiosError(error) &&
          error.response &&
          error.response.data.detail ===
            'duplicate key value violates unique constraint "offices_name_key"'
        ) {
          setErrors({ name: "Name already used" });
        } else {
          console.error("Create Office", error);
        }
      });
  };

  return (
    <ColumnContainer>
      <OfficeForm header={OfficeFormHeader.add} submitValues={submitValues} />
    </ColumnContainer>
  );
};
